import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export function CoinbaseOne({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="Coinbase One"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      viewBox="0 0 96 96"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M48.0009 0C21.4863 0 0 21.55 0 48.1396C0 72.9718 18.7549 93.409 42.834 96V59.3427C52.6264 55.2118 60.6466 47.7368 65.4987 38.3284V92.9014C83.2588 85.8385 96 68.4719 96 48.1396C96 21.55 74.5137 0 48.0009 0ZM20.6058 59.116V37.1294C32.1948 37.1294 41.7868 28.6484 43.6021 17.5409H65.6655C63.7284 40.8145 44.3103 59.116 20.6058 59.116V59.116Z" />
    </svg>
  )
}
